
import layout from '../layout'

const inventoryRoutes = { 
  path: '/inventory',
  component: layout,
  children: [
    {
      path: '/inventory/leave',
      name: 'leave',
      component: () => import('@/pages/inventory/leave')
    },
    {
      path: '/inventory/stock/:stock',
      name: 'stock',
      component: () => import('@/pages/inventory/stock')
    },
    {
      path: '/inventory/update-stock/:id',
      name: 'update-stock',
      component: () => import('@/pages/inventory/update-stock')
    },
    {
      path: '/inventory/new-stock',
      name: 'new-stock',
      component: () => import('@/pages/inventory/update-stock')
    },
  ]
};

export default inventoryRoutes;